/* assets/testimonials.js
 * Guaranteed autoplay for Minimog testimonials
 * - ticker mode (continuous)
 * - rotate mode
 * - supports swiper-container
 */

(function () {
  const isTruthy = (v) => String(v) === "true" || String(v) === "1";
  const toNumber = (v, fallback) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };

  class MTestimonials extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.init());

      document.addEventListener("shopify:section:load", (e) => {
        if (!this.closest(`[data-section-id="${e?.detail?.sectionId}"]`)) return;
        this.destroy();
        requestAnimationFrame(() => this.init());
      });
    }

    findContainer() {
      return this.querySelector(".swiper-container") || this.querySelector(".swiper");
    }

    init() {
      const el = this.findContainer();
      if (!el) return;

      const slides = el.querySelectorAll(".swiper-slide");
      if (!slides || slides.length < 2) return;

      if (typeof window.Swiper === "undefined") return;

      const autoplayEnabled = isTruthy(this.dataset.autoplay);
      const autoplayMode = (this.dataset.autoplayMode || "ticker").toLowerCase(); // ticker | rotate
      const autoplaySpeedSec = toNumber(this.dataset.autoplaySpeed, 4);
      const pauseOnHover = isTruthy(this.dataset.pauseOnHover);
      const tickerSpeedMs = toNumber(this.dataset.tickerSpeed, 8000);

      const paginationEl = this.closest("section")?.querySelector(".swiper-pagination") || el.querySelector(".swiper-pagination");
      const nextEl = this.closest("section")?.querySelector(".swiper-button-next") || el.querySelector(".swiper-button-next");
      const prevEl = this.closest("section")?.querySelector(".swiper-button-prev") || el.querySelector(".swiper-button-prev");

      const configBase = {
        loop: true,
        observer: true,
        observeParents: true,
        allowTouchMove: true
      };

      const paginationConfig = paginationEl
        ? { pagination: { el: paginationEl, clickable: true, type: this.dataset.paginationType || "bullets" } }
        : {};

      const navConfig = nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {};

      const rotateConfig = {
        speed: 600,
        spaceBetween: 24,
        slidesPerView: 1,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        },
        autoplay: autoplayEnabled
          ? { delay: autoplaySpeedSec * 1000, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover }
          : false
      };

      const tickerConfig = {
        speed: tickerSpeedMs,
        spaceBetween: 24,
        slidesPerView: "auto",
        freeMode: true,
        freeModeMomentum: false,
        centeredSlides: false,
        autoplay: autoplayEnabled
          ? { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover }
          : false
      };

      const finalConfig =
        autoplayMode === "ticker"
          ? { ...configBase, ...tickerConfig, ...paginationConfig, ...navConfig }
          : { ...configBase, ...rotateConfig, ...paginationConfig, ...navConfig };

      this.destroy();
      this.swiper = new window.Swiper(el, finalConfig);

      // Force start autoplay (some themes stop it)
      if (autoplayEnabled && this.swiper?.autoplay) {
        try {
          this.swiper.autoplay.start();
        } catch (e) {}
      }
    }

    destroy() {
      try {
        if (this.swiper?.destroy) this.swiper.destroy(true, true);
      } catch (e) {}
      this.swiper = null;
    }
  }

  if (!customElements.get("m-testimonials")) {
    customElements.define("m-testimonials", MTestimonials);
  }
})();
/* --- FORCE AUTOPLAY START (ticker/rotate) --- */
document.addEventListener("DOMContentLoaded", () => {
  const isTruthy = (v) => String(v) === "true" || String(v) === "1";

  document.querySelectorAll("m-testimonials.m-testimonials-el").forEach((wrap) => {
    const autoplayEnabled = isTruthy(wrap.dataset.autoplay);
    if (!autoplayEnabled) return;

    const mode = (wrap.dataset.autoplayMode || "rotate").toLowerCase();
    const tickerSpeed = Number(wrap.dataset.tickerSpeed || 8000);
    const rotateDelay = Number(wrap.dataset.autoplaySpeed || 4) * 1000;

    // Find swiper element used by theme
    const swiperEl =
      wrap.querySelector(".swiper-container") ||
      wrap.querySelector(".swiper");

    if (!swiperEl) return;

    // If swiper already initialized by theme, just start autoplay
    if (swiperEl.swiper) {
      try {
        if (mode === "ticker") {
          swiperEl.swiper.params.speed = tickerSpeed;
          swiperEl.swiper.params.autoplay = { delay: 0, disableOnInteraction: false };
          swiperEl.swiper.params.freeMode = true;
          swiperEl.swiper.params.freeModeMomentum = false;
          swiperEl.swiper.update();
        } else {
          swiperEl.swiper.params.autoplay = { delay: rotateDelay, disableOnInteraction: false };
          swiperEl.swiper.update();
        }

        swiperEl.swiper.autoplay?.start?.();
      } catch (e) {}
      return;
    }

    // If theme didn't initialize swiper for some reason, create one
    if (typeof window.Swiper === "undefined") return;

    const config =
      mode === "ticker"
        ? {
            loop: true,
            speed: tickerSpeed,
            autoplay: { delay: 0, disableOnInteraction: false },
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            freeModeMomentum: false
          }
        : {
            loop: true,
            speed: 600,
            autoplay: { delay: rotateDelay, disableOnInteraction: false },
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 }
            }
          };

    try {
      new window.Swiper(swiperEl, config);
    } catch (e) {}
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.m-testimonials-el[data-autoplay-mode="ticker"]').forEach(el => {
    const swiperEl = el.querySelector('.swiper');
    if (!swiperEl || !swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const speedSeconds = Number(el.dataset.tickerSpeed || 20);

    swiper.params.autoplay = {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: el.dataset.pauseOnHover === 'true'
    };

    swiper.params.speed = speedSeconds * 1000;
    swiper.params.loop = true;
    swiper.params.allowTouchMove = false;

    swiper.update();
    swiper.autoplay.start();
  });
});
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-testimonial-image');
  if (!btn) return;

  const section = btn.closest('[data-section-id]');
  if (!section) return;

  const lightbox = document.getElementById(`testimonial-lightbox-${section.dataset.sectionId}`);
  if (!lightbox) return;

  const img = lightbox.querySelector('img');
  img.src = btn.dataset.image;

  lightbox.classList.add('is-active');
  lightbox.setAttribute('aria-hidden', 'false');
});

document.addEventListener('click', function (e) {
  const lb = e.target.closest('.testimonial-lightbox');
  if (!lb) return;

  if (e.target.classList.contains('testimonial-lightbox') || e.target.classList.contains('testimonial-lightbox__overlay')) {
    lb.classList.remove('is-active');
    lb.setAttribute('aria-hidden', 'true');

    const img = lb.querySelector('img');
    if (img) img.src = '';
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.m-testimonial__image');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.2 });

  images.forEach(img => observer.observe(img));
});
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".m-testimonials-el[data-autoplay-mode='ticker']").forEach(el => {
    const wrapper = el.querySelector(".swiper-wrapper");
    if (!wrapper || wrapper.dataset.cloned) return;

    // Clone slides once
    Array.from(wrapper.children).forEach(slide => {
      wrapper.appendChild(slide.cloneNode(true));
    });

    wrapper.dataset.cloned = "true";

    // Stop Swiper from overriding CSS animation
    wrapper.style.transform = "none";
    wrapper.style.transition = "none";
  });
});
/* =========================================================
   QUICK VIEW (Testimonials)
   - Opens modal
   - Loads product quickview html
   - Works with buttons having .m-testimonial__quickview + data-qv-url
========================================================= */
document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".m-testimonial__quickview");
  if (!btn) return;

  e.preventDefault();

  const section = btn.closest("section[data-section-id]");
  if (!section) return;

  const sectionId = section.getAttribute("data-section-id");
  const modal = document.getElementById("m-qv-" + sectionId);
  if (!modal) return;

  const bodyEl = modal.querySelector("[data-qv-body]");
  if (!bodyEl) return;

  const url = btn.getAttribute("data-qv-url");
  if (!url) return;

  const openModal = () => {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    bodyEl.innerHTML = "";
    document.body.style.overflow = "";
  };

  // attach close listeners once
  if (!modal.dataset.qvBound) {
    modal.addEventListener("click", function (ev) {
      if (
        ev.target.hasAttribute("data-qv-close") ||
        ev.target.closest("[data-qv-close]")
      ) {
        closeModal();
      }
    });

    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    modal.dataset.qvBound = "true";
  }

  openModal();
  bodyEl.innerHTML = '<div style="padding:16px">Loading…</div>';

  try {
    // Minimog common quickview endpoints
    const tryUrls = [
      url + (url.includes("?") ? "&" : "?") + "view=quickview",
      url + (url.includes("?") ? "&" : "?") + "view=quick-view",
      url + (url.includes("?") ? "&" : "?") + "section_id=product-quick-view"
    ];

    let html = "";
    for (let i = 0; i < tryUrls.length; i++) {
      const res = await fetch(tryUrls[i], { credentials: "same-origin" });
      if (res.ok) {
        html = await res.text();
        if (html && html.length > 50) break;
      }
    }

    if (!html) throw new Error("Quick view template not found");

    bodyEl.innerHTML = html;
  } catch (err) {
    console.error(err);
    bodyEl.innerHTML =
      '<div style="padding:16px">Unable to load quick view. Please ensure quick view template exists.</div>';
  }
});
